<script lang="ts" setup>
withDefaults(
  defineProps<{
    count?: number;
    height?: string;
  }>(),
  {
    count: 5,
    height: "20px",
  }
);
</script>

<template>
  <div class="skeleton-list">
    <div
      class="skeleton-item"
      v-for="n in count"
      :key="n"
      :style="{ height }"
    ></div>
  </div>
</template>

<style scoped>
.skeleton-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.skeleton-item {
  width: 100%;
  background-color: #ddd;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.skeleton-item::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  animation: shimmer 1.5s infinite;
}
</style>
